import { ReactNode } from "react";

import { Link } from "react-router";

import { Container } from "@/components/pieces/bootstrap";
import { FaqCategory } from "@/components/pieces/faq/FaqCategory";
import { Button } from "@/components/ui/button";
import { MIDTEXT_COLOR } from "@/css/constants";

interface MainHeroBottomProps {
  title?: string | ReactNode;
  subtitle?: string | ReactNode;
  onCtaClick?: () => void;
  ctaLink?: string;
  ctaText: string;
  background?: string;
  faqCategory?: string;
  headerSize?: number | Array<number | string>;
}

export function MainHeroBottom({
  title = "Get Started Today",
  subtitle,
  onCtaClick,
  ctaLink,
  ctaText,
  background = "#FFF",
  faqCategory,
}: MainHeroBottomProps) {
  return (
    <div className="py-16 lg:py-20" style={{ background }}>
      <Container className="!max-w-marketing-content">
        <div className="mx-auto max-w-2xl text-center">
          <div
            className={`mb-3 font-serif text-4xl leading-tight font-light text-gray-800 md:text-5xl lg:text-6xl`}
          >
            {title}
          </div>

          <div className="mb-10 text-xl" style={{ color: MIDTEXT_COLOR }}>
            {subtitle ? (
              subtitle
            ) : (
              <>Book a demo to see how Exec can help your organization</>
            )}
          </div>

          {ctaLink && ctaText && (
            <Button size="lg" className="px-12" asChild>
              <Link to={ctaLink}>{ctaText}</Link>
            </Button>
          )}
          {onCtaClick && (
            <Button size="lg" className="px-12" onClick={onCtaClick}>
              {ctaText}
            </Button>
          )}
        </div>

        {faqCategory && (
          <div className="mt-12">
            <FaqCategory category={faqCategory} />
          </div>
        )}
      </Container>
    </div>
  );
}
